import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import MapActionForm from './form'

const MapActionDialog = React.forwardRef(function MapActionDialog ({ onComplete = () => {} }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => setDialogState({ open: true, processing: false })
  }), [setDialogState])

  return (
    <SydModal
      title='Map an Action'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<MapActionForm onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </SydModal>
  )
})

MapActionDialog.propTypes = {
  onComplete: PropTypes.func
}

export default MapActionDialog
